import Request from "@services/request";
import { ILoginFormData } from "./types";

const Login = async ({ email, password }: ILoginFormData) =>
    await new Request().post<
        ILoginFormData,
        IReturnValue<{
            token: string;
            id: number;
        }>
    >("LOGIN", {
        email,
        password,
    });

// Main Object
const AuthApis = {
    Login,
};

export default AuthApis;
